import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Button
} from '@mui/material';
import { CheckCircle, Error, Home } from '@mui/icons-material';
import { authService } from '@services/authService';

const Activate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const activateAccount = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('Token de activare lipsa!');
        setLoading(false);
        return;
      }

      try {
        const response = await authService.activateAccount(token);
        
        if (response.success) {
          setSuccess(response.message || 'Cont activat cu succes!');
        } else {
          setError(response.error || 'Eroare la activarea contului');
        }
      } catch (err) {
        setError('Eroare la activarea contului. Incearca din nou.');
      } finally {
        setLoading(false);
      }
    };

    activateAccount();
  }, [searchParams]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <CircularProgress size={60} />
            <Typography variant="h6" color="text.secondary">
              Se activeaza contul...
            </Typography>
          </Box>
        ) : success ? (
          <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
            <CheckCircle sx={{ fontSize: 80, color: 'success.main' }} />
            <Typography variant="h4" component="h1" color="success.main" gutterBottom>
              Cont Activ!
            </Typography>
            <Alert severity="success" sx={{ width: '100%' }}>
              {success}
            </Alert>
            <Typography variant="body1" color="text.secondary">
              Contul tau a fost activat cu succes. Acum te poti conecta.
            </Typography>
            <Box display="flex" gap={2} mt={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGoToLogin}
                startIcon={<Home />}
              >
                Mergi la Login
              </Button>
              <Button
                variant="outlined"
                onClick={handleGoHome}
              >
                Acasa
              </Button>
            </Box>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
            <Error sx={{ fontSize: 80, color: 'error.main' }} />
            <Typography variant="h4" component="h1" color="error.main" gutterBottom>
              Eroare la Activare
            </Typography>
            <Alert severity="error" sx={{ width: '100%' }}>
              {error}
            </Alert>
            <Typography variant="body1" color="text.secondary">
              Nu s-a putut activa contul. Verifica linkul sau contacteaza suportul.
            </Typography>
            <Box display="flex" gap={2} mt={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGoToLogin}
                startIcon={<Home />}
              >
                Mergi la Login
              </Button>
              <Button
                variant="outlined"
                onClick={handleGoHome}
              >
                Acasa
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default Activate; 
